/**
 * The platform console's gate for an org's improvement projects (docs/plans/2026-10-05_improvement-projects.md; POST and
 * DELETE /v1/admin/orgs/{org_id}/improvement-projects, org_settings.improvement_projects_allowed, migration 0200). Open,
 * the org's admins may turn projects on (Admin, Packs); shut, the default, their switch is not shown and every project
 * route is off whatever the org's own switch says. The API process's IMPROVEMENT_PROJECTS_ENABLED opens the gate to every
 * org, whatever this says. Its words; pure.
 */
import type { OrgSummary } from "@/lib/api/platform-admin";

export const PROJECTS_GATE_HEADER_TITLE =
  "The platform's gate for improvement projects. Open, the org's admins can turn them on. The API process's IMPROVEMENT_PROJECTS_ENABLED opens it to every org, whatever this says.";
export const PROJECTS_GATE_ON_TITLE =
  "Improvement projects open: this org's admins can turn them on. Click to shut them (its projects are hidden and kept)";
export const PROJECTS_GATE_OFF_TITLE =
  "Improvement projects shut. Click to open them to this org, so its admins can turn them on";
export const PROJECTS_GATE_FAILED = "Couldn't switch improvement projects.";

/** What a switch of the gate did, in the toast. */
export function projectsGateToast(orgName: string, open: boolean): string {
  return open
    ? `Improvement projects opened to ${orgName}: its org admins can now turn them on.`
    : `Improvement projects shut for ${orgName}: its projects are hidden and kept.`;
}

/** Whether the org's own gate is open; an org the list gives no flag for (an older API build) reads as shut. */
export function projectsGateOpen(org: Pick<OrgSummary, "improvement_projects_allowed">): boolean {
  return org?.improvement_projects_allowed === true;
}
